var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRingingBellNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ringing Bell Notification",
    clipPath: "url(#clip0_42_9765)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ringing-bell-notification--notification-vibrate-ring-sound-alarm-alert-bell-noise"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.57153 19.4286H11.4287",
    stroke: "#5D5F62",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.7143 8.71429C15.7143 7.19876 15.1123 5.74531 14.0406 4.67367C12.9689 3.60204 11.5155 3 9.99997 3C8.48444 3 7.03099 3.60204 5.95935 4.67367C4.88772 5.74531 4.28568 7.19876 4.28568 8.71429V13.7143C4.28568 14.2826 4.05991 14.8277 3.65805 15.2296C3.25619 15.6314 2.71114 15.8571 2.14282 15.8571H17.8571C17.2888 15.8571 16.7437 15.6314 16.3418 15.2296C15.94 14.8277 15.7143 14.2826 15.7143 13.7143V8.71429Z",
    stroke: "#5D5F62",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M0.714355 8.52858C0.715125 7.16878 1.0394 5.82868 1.66041 4.61897C2.28141 3.40926 3.18131 2.36466 4.28578 1.57144",
    stroke: "#5D5F62",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M19.2858 8.52858C19.2851 7.16878 18.9608 5.82868 18.3398 4.61897C17.7188 3.40926 16.8188 2.36466 15.7144 1.57144",
    stroke: "#5D5F62",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_42_9765"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRingingBellNotification);
export default __webpack_public_path__ + "static/media/Ringing Bell Notification.c2423ef345fc4ac6599e76a616dc3838.svg";
export { ForwardRef as ReactComponent };